export const getFullNamePreview = ({
  name,
  academicLevelName
}: {
  name: string
  academicLevelName: string
}) => `${academicLevelName}${name}`
